<script>
export default {
  name: "MHIFooter",
  data() {
    return {
      year: new Date().getFullYear(),
    };
  },
};
</script>
<template>
  <div class="container-fluid footer">
    <div class="container pt-5 footer text-light">
      <div class="row">
        <div class="col-12">
          <h4>
            <a class="navbar-brand lora" href="https://www.mhisystems.com/">
              MHIsystems.com
            </a>
          </h4>
        </div>
        <div class="col-md-4">
            <p>
                107 Carpenter Dr, Suite 210<br>
                Sterling, VA 20164-4468<br>
                United States
            </p>
        </div>
        <div class="col-md-4">
          <p>
            <strong>Patient</strong><br>
            <router-link to="/register/patient"> Patient Sign Up </router-link>
          </p>
        </div>
        <div class="col-md-4">
          <p>
            <strong>Provider</strong><br>
            <router-link to="/register/provider"> Provider Sign up </router-link>
          </p>
        </div>
        <div class="col-12">
          <p>&copy; {{ year }} MHIsystems Inc. All Rights Reserved</p>
        </div>
      </div>
    </div>
  </div>
</template>
